import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { pageTitleFromPath } from './utils'

const PageTracker = WrappedComponent => {
  const HOC = props => {
    const location = useLocation()

    useEffect(() => {
      try {
        const { pathname } = location
        document.title = pageTitleFromPath(pathname)

        analytics.page()

        // Occasionally we need to style elements that live outside of our component, like intercom, but only on certain pages.
        // So make a classname available on the top-level body element
        const bodyElement = document.querySelector('body')
        bodyElement.setAttribute('class', `body-${pathname.split('/')[1]}`)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps -- only pathname triggers (same as prior withRouter)
    }, [location.pathname])

    return <WrappedComponent {...props} />
  }

  return HOC
}

export default PageTracker
